import { useEffect } from "react";

export const useOrthomosaic = (potreeViewer, orthomosaicUrl, pointCloudBounds, guiLoaded) => {
  useEffect(() => {
    if (!potreeViewer || !orthomosaicUrl || !guiLoaded || !pointCloudBounds) return;
    potreeViewer.scene.addOrthomosaic(orthomosaicUrl, pointCloudBounds);
  }, [potreeViewer, orthomosaicUrl, guiLoaded, pointCloudBounds]);
};
